// extracted by mini-css-extract-plugin
module.exports = {"root":"working-hours_root__JYFhT"};